import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { Input } from './Input'

import style from './Checkbox.scss'

let counter = 0
function uid() {
  counter += 1
  return `check-${counter}`
}

class Checkbox extends Component {
  static propTypes = {
    id: PropTypes.string,
    model: PropTypes.shape({
      name: PropTypes.string,
      checked: PropTypes.bool.isRequired,
    }),
    name: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
    onChange: PropTypes.func.isRequired,
  }

  onChange = (event) => {
    this.props.onChange(event, {
      name: event.target.name,
      checked: event.target.checked,
    })
  }

  render() {
    const { className, model, children, disabled, readOnly, autoFocus } = this.props
    let { id, name, checked } = this.props
    const componentClass = cx(style.checkbox, { [className]: className })
    id = id || uid()

    name = model ? model.name : name
    checked = model ? model.checked : checked

    return (
      <div className={componentClass}>
        <Input
          id={id}
          type="checkbox"
          name={name}
          disabled={disabled}
          readOnly={readOnly}
          autoFocus={autoFocus}
          checked={checked}
          onChange={this.onChange}
        />
        <label htmlFor={id}>{children}</label>
      </div>
    )
  }
}

export default Checkbox



// WEBPACK FOOTER //
// ./src/components/Common/Checkbox.js